// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__2zANN","col":"styles_col__378N9"};